import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  FormControl,
  Divider,
  Stack
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useStoreActions } from 'easy-peasy';
import Autocomplete from '../../../components/Autocomplete';
import api from '../../../services/api';
import { DateField, TextField, IntegerField } from '../../../components';
import Select from '../../../components/Select';
import { nivelHierarquico, tiposDeImplantacao, ObjBoolean } from './constants';
import yupnanable from '../../../services/yup-nanable.js';


const Dados =({watchEmpresaId, ano})=>{
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const schema = yup.object({
    fezAdesaoProx:  yup.number().positive().nullable()
      .label('Já aderiu'),
    planejaAdesaoProx:  yup.number().positive().nullable()
      .label('Planeja aderir'),
    quandoPlanejaAdesaoProx: yup.date().nullable()
      .label('Data da adesão'),
    observacoes: yup.string().nullable()
      .max(1000, 'Máximo 1000 caracteres')
      .label('Observações'),
    planejamentoGestaoRejeitos:  yup.number().positive().nullable()
      .label('Gestão de Rejeitos'),
    tipoDeImplantacao: yup.number().nullable()
      .label('Implantação'),
    prevInicioImplantacao: yup.date().nullable()
      .label('Início implantação'),
    prevFinalizacaoImplantacao: yup.date().nullable()
      .label('Fim implantação'),
    mediaParaEstruturas: yup.number().nullable().nanable()
      .label('Aderência (%)'),
    tipoGapAssessment:  yup.number().nullable().positive()
      .label('gap assessment'),
    definiuExecutivoResp:  yup.number().nullable().positive()
      .label('Definiu executivo'),
    nivelHierarquicoProfissional: yup.number().nullable()
      .label('Nível executivo'),
    implementouCirrItrb:  yup.number().nullable().positive()
      .label('CIRR ou ITRB'),
    prevFinalizacaoImplementacao: yup.date().nullable()
      .label('Finalização'),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
  });

  const { handleSubmit, reset,
          watch, formState: { isDirty, isSubmitting },
          setValue
        } = useFormRef;

  const fezAdesaoProx= watch('fezAdesaoProx');
  const planejaAdesaoProx = watch('planejaAdesaoProx');
  const planejamentoGestaoRejeitos = watch('planejamentoGestaoRejeitos');
  const implementouCirrItrb = watch('implementouCirrItrb');

  // Altera os estados para null caso input nao esteja habilitado
  useEffect(()=>{
    if(planejamentoGestaoRejeitos == 2){
      setValue('tipoDeImplantacao',null);
      setValue('prevInicioImplantacao',null);
      setValue('prevFinalizacaoImplantacao',null);
      setValue('mediaParaEstruturas','');
      setValue('tipoGapAssessment',null);
      setValue('definiuExecutivoResp',null);
      setValue('nivelHierarquicoProfissional',null);
      setValue('implementouCirrItrb',null);
      setValue('prevFinalizacaoImplementacao',null);
    }
  },[planejamentoGestaoRejeitos]);

  useEffect(()=>{
    if(implementouCirrItrb == 2){
      setValue('prevFinalizacaoImplementacao',null);
    }
  },[implementouCirrItrb]);

  useEffect(()=>{
    if(fezAdesaoProx != 2){
      setValue('planejaAdesaoProx',null);
    }
  },[fezAdesaoProx]);

  useEffect(()=>{
    if(planejaAdesaoProx != 1){
      setValue('quandoPlanejaAdesaoProx',null);
    }
  },[planejaAdesaoProx]);


  const onSave = async (data) => {
    startLoading();
    let result;
    try {
      if (data.id) {
        result = await api.http.put(
          `/02/gestao-rejeitos/empresa/${watchEmpresaId}/${data.id}`, {
            ...data,
            ano
          }
        );
      } else {
        result = await api.http.post(
          `/02/gestao-rejeitos/empresa/${watchEmpresaId}`, {
            ...data,
            ano
          }
        );
      }
      reset(result.data);
      stopLoading({ severity: 'success' });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    };
  };

  const loadGestaoRejeitos = async (mount) => {
    startLoading();
    try {
      let getGestaoRejeitos = (
        await api.http.get(
          `/02/gestao-rejeitos/empresa/${watchEmpresaId}/${ano}`
        )
      );

      const data = getGestaoRejeitos.data;
      const parseDate = (date) => (date ? new Date(date) : null);
      const filled = {
        ...data,
        quandoPlanejaAdesaoProx: parseDate(data.quandoPlanejaAdesaoProx),
        prevInicioImplantacao: parseDate(data.prevInicioImplantacao),
        prevFinalizacaoImplantacao: parseDate(data.prevFinalizacaoImplantacao),
        prevFinalizacaoImplementacao: parseDate(
          data.prevFinalizacaoImplementacao
        ),
      };
      if (mount.isMounted) {
        reset(filled);
      }
      stopLoading();
    } catch (error) {
      if(error.response && error.response.status==404) {
        if(mount.isMounted) {
          reset({
            fezAdesaoProx:null,
            planejaAdesaoProx: null,
            quandoPlanejaAdesaoProx:null,
            observacoes: null,
            planejamentoGestaoRejeitos:null,
            tipoDeImplantacao: '',
            prevInicioImplantacao:null,
            prevFinalizacaoImplantacao:null,
            mediaParaEstruturas: '',
            tipoGapAssessment:null,
            definiuExecutivoResp:null,
            nivelHierarquicoProfissional:null,
            implementouCirrItrb:null,
            prevFinalizacaoImplementacao:null,
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
    };
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadGestaoRejeitos(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [watchEmpresaId ,ano]);


  return (<>
    <Box
      component="form"
    >
      <Grid container spacing={2} sx={{
        '& p': {textAlign: 'right'},
        '& .MuiGrid-root':{p:1}
      }}>
        <Grid
          size={{
            md: 9
          }}>
          <p>A empresa já fez a adesão da utilização do aplicativo PROX?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <Select
              field="fezAdesaoProx"
              useFormRef={useFormRef}
              options={ObjBoolean}
              getOptionLabel={(boolean) => boolean.label}
              schema={schema} />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <p>A empresa planeja fazer a adesão do aplicativo PROX?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <Select
              field="planejaAdesaoProx"
              useFormRef={useFormRef}
              options={ObjBoolean}
              getOptionLabel={(boolean) => boolean.label}
              schema={schema}
              disabled={fezAdesaoProx==2?false:true}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <p>Quando sua empresa planeja fazer a adesão do aplicativo PROX?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <DateField
              field="quandoPlanejaAdesaoProx"
              views={['year', 'month']}
              inputFormat={"MM/yyyy"}
              useFormRef={useFormRef}
              schema={schema}
              disabled={planejaAdesaoProx==1?false:true}
            />
          </FormControl>
        </Grid>
      </Grid>
    </Box>
    <br></br>
    <Divider>
      <h3>Padrão Global da Indústria para Gestão de Rejeitos</h3>
    </Divider>
    <Box
      component="form"
    >
      <Grid container spacing={2} sx={{
        '& p': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 }
      }}>
        <Grid
          size={{
            md: 9
          }}>
          <p>A empresa tem planejamento para implementar o Padrão Global da Indústria para Gestão de Rejeitos em suas operações?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <Select
              field="planejamentoGestaoRejeitos"
              useFormRef={useFormRef}
              options={ObjBoolean}
              getOptionLabel={(boolean) => boolean.label}
              schema={schema} />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <p>Qual tipo de implantação pretende fazer?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <Autocomplete
              field="tipoDeImplantacao"
              useFormRef={useFormRef}
              options={tiposDeImplantacao}
              getOptionLabel={(implantacao) => implantacao.label}
              schema={schema}
              disabled={planejamentoGestaoRejeitos==1?false:true}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <p>Previsão para início da implantação:</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <DateField
              field="prevInicioImplantacao"
              views={['year', 'month']}
              inputFormat={"MM/yyyy"}
              useFormRef={useFormRef}
              schema={schema}
              disabled={planejamentoGestaoRejeitos==1?false:true}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <p>Previsão para a finalização da implantação:</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <DateField
              field="prevFinalizacaoImplantacao"
              views={['year', 'month']}
              inputFormat={"MM/yyyy"}
              useFormRef={useFormRef}
              schema={schema}
              disabled={planejamentoGestaoRejeitos==1?false:true}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <p>Qual a percepção de aderência da empresa em relação aos tópicos abordados no Padrão
            Global da Indústria para Gestão de Rejeitos (média para todas as estruturas em %)?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <IntegerField
              field="mediaParaEstruturas"
              useFormRef={useFormRef}
              schema={schema}
              disabled={planejamentoGestaoRejeitos==1?false:true}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <p>A aderência é baseada em uma avaliação formal do tipo “gap assessment”?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <Select
              field="tipoGapAssessment"
              useFormRef={useFormRef}
              options={ObjBoolean}
              getOptionLabel={(boolean) => boolean.label}
              schema={schema}
              disabled={planejamentoGestaoRejeitos==1?false:true}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <p>A empresa já definiu quem será o Executivo Responsável?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <Select
              field="definiuExecutivoResp"
              useFormRef={useFormRef}
              options={ObjBoolean}
              getOptionLabel={(boolean) => boolean.label}
              schema={schema}
              disabled={planejamentoGestaoRejeitos==1?false:true}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <p>Qual o nível hierárquico desse profissional?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <Autocomplete
              field="nivelHierarquicoProfissional"
              useFormRef={useFormRef}
              options={nivelHierarquico}
              getOptionLabel={(nivel) => nivel.label}
              schema={schema}
              disabled={planejamentoGestaoRejeitos==1?false:true}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <p>A empresa já implementou o Conselho Independente de Gestão de Rejeitos (CIRR ou ITRB)?</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <Select
              field="implementouCirrItrb"
              useFormRef={useFormRef}
              options={ObjBoolean}
              getOptionLabel={(boolean) => boolean.label}
              schema={schema}
              disabled={planejamentoGestaoRejeitos==1?false:true}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <p>Previsão para a finalização da implementação:</p>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <DateField
              field="prevFinalizacaoImplementacao"
              views={['year', 'month']}
              disabled={implementouCirrItrb==1?false:true}
              inputFormat={"MM/yyyy"}
              useFormRef={useFormRef}
              schema={schema} />
          </FormControl>
        </Grid>
      </Grid>
    </Box>
    <br></br>
    <Divider>
      <h3>Observações</h3>
    </Divider>
    <Box
      component="form"
    >
      <Stack direction="row" spacing={2}>
        <FormControl fullWidth>
          <TextField
            field="observacoes"
            type="text"
            multiline rows={4}
            useFormRef={useFormRef}
            schema={schema}
            inputProps={{ maxLength: 1000 }} />
        </FormControl>
      </Stack>
    </Box>
    <Grid style={{ 'textAlign': 'center' }} size="grow">
      <Button variant="outlined" sx={{ mr: 2 }}
              onClick={()=>{reset();}} disabled={!isDirty || isSubmitting}>
        CANCELAR
      </Button>
      <Button sx={{ my: 2 }}
              variant="contained"
              onClick={handleSubmit(onSave)}
              disabled={!isDirty || isSubmitting}>
        Salvar
      </Button>
    </Grid>
  </>);
};

export default Dados;
